'use strict';

import { Scrollbar } from './Scrollbar';

export function Modal() {
  let scrollPosition;

	const $modalTrigger = $('.js-modal-trigger');
	const $modalClose = $('.js-modal-close');

	$modalTrigger.on('click', function () {
		const href = $(this).attr('data-modal');
		const modal = $(href == "#" || href == "" ? 'html' : href);
		$(modal).show();
    setTimeout(function () {
      $(modal).addClass('is-active');
      Scrollbar();
    }, 100);
    if (window.innerWidth < 768) {
      scrollPosition = $(window).scrollTop();
      $('body').addClass('is-locked').css({ 'top': -scrollPosition });
    }

		$modalClose.on('click', function () {
			$(modal).removeClass('is-active');
			setTimeout(function () {
				$(modal).hide();
      }, 400)
      if (window.innerWidth < 768) {
        $('body').removeClass('is-locked').css({ 'top': '' });
        window.scrollTo(0, scrollPosition);
      }

		});
	});
}
